import { useState, useEffect, useRef, } from "react";
import { useContext, useMemo } from "react";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Transmitter from "../components/Transmitter";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import Valve from "../components/Valve";
import "./LoadingGantry.css";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import { PumpContext } from "../context/PumpContext"; 
import { ProcessContext } from "../context/ProcessContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";
import { truckDatabase } from "../data/truckDatabase";
import { bargeDatabase } from "../data/bargeDatabase";
import LoadingReceipt from "../components/LoadingReceipt";
import nkLogo from "../../src/assets/NK LOGO.jpg";



import { trackPageVisit } from "../competency/PageTracker";
import TransmitterFaceplate from "../components/TransmitterFaceplate";





function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}



function LoadingGantry() {

    useEffect(() => {
    
      trackPageVisit("LoadingGantry");
    
    }, []);
  
     const {  valves, toggleValve} = useContext(WellContext);

const [hoveredValve, setHoveredValve] = useState(null);
  const {processData,  setProcessData} = useContext(ProcessContext);



const [showReceipt, setShowReceipt] = useState(false);

  const [showSelector, setShowSelector] = useState(false);

     

  const DEFAULT_VALVES = {
  FCV_3901: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_3902: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_3903: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_3904: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("LoadingGantry_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_3901: { ...DEFAULT_VALVES.FCV_3901, ...parsed.FCV_3901 },
      FCV_3902: { ...DEFAULT_VALVES.FCV_3902, ...parsed.FCV_3902 },
      FCV_3903: { ...DEFAULT_VALVES.FCV_3903, ...parsed.FCV_3903 },
      FCV_3904: { ...DEFAULT_VALVES.FCV_3904, ...parsed.FCV_3904 },

    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("LoadingGantry_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};





const [panelPos, setPanelPos] = useState({ x: 0, y: 80 });
const [dragging, setDragging] = useState(false);
const offsetRef = useRef({ x: 0, y: 0 });

const handleMouseDown = (e) => {
  setDragging(true);

  offsetRef.current = {
    x: e.clientX - panelPos.x,
    y: e.clientY - panelPos.y,
  };
};

const handleMouseMove = (e) => {
  if (!dragging) return;

  setPanelPos({
    x: e.clientX - offsetRef.current.x,
    y: e.clientY - offsetRef.current.y,
  });
};

const handleMouseUp = () => {
  setDragging(false);
};

useEffect(() => {
  window.addEventListener("mousemove", handleMouseMove);
  window.addEventListener("mouseup", handleMouseUp);

  return () => {
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };
}, [dragging]);




const tagStyle = {
      position: "absolute",
      top: -30,
      left: "50%",
      transform: "translateX(-50%)",

      background: "black",
      color: "#00ffcc",

      fontSize: "13px",
      fontWeight: "bold",

      padding: "3px 8px",
      borderRadius: "4px",

      border: "1px solid #555",

      whiteSpace: "nowrap",
      zIndex: 999
    };


// ================= RETREIVING OF DATA FROM OTHER PAGES VIA LOCAL STROAGE =================
    
                const { transmitters,  } = usePlantStore();
                const FIC_3804 = transmitters.FIC_3804 || 0;
                const FIC_3707 = transmitters.FIC_3707 || 0;
                const FIC_3507 = transmitters.FIC_3507 || 0;
                const FIC_3607 = transmitters.FIC_3607 || 0;
                const FIC_3407 = transmitters.FIC_3407 || 0;
  
  








const [bargePosition, setBargePosition] = useState(() => {

  const saved =
    localStorage.getItem("bargePosition");

  return saved
    ? JSON.parse(saved)
    : {
        left: "-2000px",
        top: "300px",
      };

});

useEffect(() => {

  localStorage.setItem(
    "bargePosition",
    JSON.stringify(bargePosition)
  );

}, [bargePosition]);



const [isBargeArrived, setIsBargeArrived] = useState(() => {
  return JSON.parse(
    localStorage.getItem("isBargeArrived")
  ) || false;
});

useEffect(() => {
  localStorage.setItem(
    "isBargeArrived",
    JSON.stringify(isBargeArrived)
  );
}, [isBargeArrived]);



const [rotation, setRotation] = useState("0deg");

const handleBargeMovement = () => {

  // ================= ARRIVAL =================
  if (!isBargeArrived) {

    setRotation("0deg");

    setBargePosition({
      left: "200px",
      top: "300px",
    });

    setIsBargeArrived(true);

    
  }

  // ================= DEPARTURE =================
  else {

    setRotation("180deg");

    setTimeout(() => {

      setBargePosition({
        left: "-2000px",
        top: "380px",
      });

    }, 300);

    setIsBargeArrived(false);
  }
};









/* ====================================================
   TRUCK MOVEMENT STATES
==================================================== */

const [truckPosition, setTruckPosition] = useState(() => {
  const saved = localStorage.getItem("truckPosition");

  return saved
    ? JSON.parse(saved)
    : { left: -900, top: 320 };
});

const [isTruckArrived, setIsTruckArrived] = useState(() => {
  return JSON.parse(
    localStorage.getItem("isTruckArrived") || "false"
  );
});

const [truckMoving, setTruckMoving] = useState(false);

const [rotation1, setRotation1] = useState("0deg");

const [truckVisible, setTruckVisible] = useState(true);

/* ====================================================
   TRUCK INVENTORY
==================================================== */





// ================= TRUCK MOVEMENT =================

const handleTruckMovement = () => {

  // ================= ARRIVAL =================

  if (!isTruckArrived) {

    setTruckMoving(true);

    setTruckVisible(true);

    setTruckPosition({
      left: 200,
      top: 320
    });

    setTimeout(() => {

      setTruckMoving(false);

      setIsTruckArrived(true);

      setTruckVisible(true);

    }, 8000);

  }

  // ================= DEPARTURE =================

  else {

    setTruckMoving(true);

    setTruckPosition({
      left: 1800,
      top: 320
    });

    setTimeout(() => {

      setTruckMoving(false);

      setIsTruckArrived(false);

      setTruckVisible(false);

      // Reset truck offscreen for next arrival
      setTruckPosition({
        left: -900,
        top: 320
      });

    }, 8000);

  }

};






useEffect(() => {

  localStorage.setItem(
    "truckPosition",
    JSON.stringify(truckPosition)
  );

}, [truckPosition]);



useEffect(() => {

  localStorage.setItem(
    "isTruckArrived",
    JSON.stringify(isTruckArrived)
  );

}, [isTruckArrived]);







const FIC_5902 =
    truckPosition.left <= 100
        ? 1000000
        : 0;


const FIC_5903 =
    bargePosition.left <= 100
        ? 1000000
        : 0;








/* ==========================================
   ACTIVE LOADED PRODUCT
========================================== */

const currentProduct = useMemo(() => {

    const MIN_FLOW = 0.1;

    const products = [
        {
            name: "ATMOSPHERIC RESIDUE",
            value: Number(FIC_3407) || 0
        },
        {
            name: "NAPHTHA",
            value: Number(FIC_3507) || 0
        },
        {
            name: "DIESEL",
            value: Number(FIC_3607) || 0
        },
        {
            name: "KEROSENE",
            value: Number(FIC_3707) || 0
        },
        {
            name: "LPG / NGL",
            value: Number(FIC_3804) || 0
        }
    ];

    const highestFlow = products.reduce((highest, current) =>
        current.value > highest.value ? current : highest
    );

    return highestFlow.value >= MIN_FLOW
        ? highestFlow.name
        : "NO PRODUCT";

}, [
    FIC_3407,
    FIC_3507,
    FIC_3607,
    FIC_3707,
    FIC_3804
]);



useEffect(() => {

    setProcessData(prev => ({
        ...prev,
        PRODUCT_NAME: currentProduct
    }));

}, [currentProduct]);



useEffect(() => {
    console.log("Saved Product:", processData.PRODUCT_NAME);
}, [processData.PRODUCT_NAME]);




  const xv3901Open = !valves?.XV_3901;

/* ===========================================================
   LOADING GANTRY PROCESS DATA
=========================================================== */

const loadingMode = processData.LOADING_MODE || null;
// values:
// null
// "truck"
// "ship"

const quantityBBL = processData.QUANTITY_BBL || 0;
const accumulatorBBL = Number(processData.ACCUMULATOR_BBL) || 0;
const batchStatus = processData.BATCH_STATUS || "READY";

const selectedTruck = processData.SELECTED_TRUCK || "";
const selectedBarge = processData.SELECTED_BARGE || "";


/* ===========================================================
   SETTERS
=========================================================== */

const setLoadingMode = (mode) => {

    setProcessData(prev => ({
        ...prev,
        LOADING_MODE: mode
    }));

};

const setQuantityBBL = (value) => {

    setProcessData(prev => ({
        ...prev,
        QUANTITY_BBL: Number(value) || 0
    }));

};

const setAccumulatorBBL = (value) => {

    setProcessData(prev => ({
        ...prev,
        ACCUMULATOR_BBL: Number(value) || 0
    }));

};

const setBatchStatus = (status) => {

    setProcessData(prev => ({
        ...prev,
        BATCH_STATUS: status
    }));

};

const setSelectedTruck = (truck) => {

    setProcessData(prev => ({
        ...prev,
        SELECTED_TRUCK: truck
    }));

};

const setSelectedBarge = (barge) => {

    setProcessData(prev => ({
        ...prev,
        SELECTED_BARGE: barge
    }));

};


/* ===========================================================
   CONVERSIONS
=========================================================== */

const quantityMT =
quantityBBL * 0.136;

const quantityLitres =
quantityBBL * 158.987;


/* ===========================================================
   FLOW
=========================================================== */

const flowBBL =
xv3901Open
    ? FIC_3407 +
      FIC_3507 +
      FIC_3607 +
      FIC_3707 +
      FIC_3804
    : 0;

const flowLPM =
flowBBL * 158.987;

const accumulatorLitres =
accumulatorBBL * 158.987;


/* ===========================================================
   FLOW ACCUMULATOR
=========================================================== */

useEffect(() => {

    const interval = setInterval(() => {

        if (flowBBL <= 0) return;

        const next = Math.min(
            accumulatorBBL + (flowBBL),
            quantityBBL
        );

        setAccumulatorBBL(next);

    }, 1000);

    return () => clearInterval(interval);

}, [
    flowBBL,
    accumulatorBBL,
    quantityBBL
]);


/* ===========================================================
   RESET BUTTONS
=========================================================== */

const resetQuantity = () => {

    setQuantityBBL(0);

    setBatchStatus("RESET");

};

const resetAccumulator = () => {

    setAccumulatorBBL(0);

    setBatchStatus("RESET");

};


/* ===========================================================
   AUTOMATIC BATCH STATUS
=========================================================== */

useEffect(() => {

    if(quantityBBL===0){

        setBatchStatus("READY");

        return;

    }

    if(
        accumulatorBBL >= quantityBBL &&
        quantityBBL > 0
    ){

        setBatchStatus("COMPLETE");

        return;

    }

    if(flowBBL>0){

        setBatchStatus("LOADING");

        return;

    }

    if(
        accumulatorBBL>0 &&
        accumulatorBBL<quantityBBL &&
        flowBBL===0 &&
        !xv3901Open
    ){

        setBatchStatus("INTERRUPTED");

    }

},[
    quantityBBL,
    accumulatorBBL,
    flowBBL,
    xv3901Open
]);





/* ===========================================================
   AUTO SHUTDOWN
=========================================================== */

useEffect(() => {

    if(
        quantityBBL>0 &&
        accumulatorBBL>=quantityBBL &&
        xv3901Open
    ){

        toggleValve("XV_3901");

    }

},[
    accumulatorBBL,
    quantityBBL,
    xv3901Open,
    toggleValve
]);


/* ===========================================================
   AUTO LOAD SELECTED TRUCK CAPACITY
=========================================================== */

useEffect(() => {

    if(
        loadingMode==="truck" &&
        selectedTruck
    ){

        setQuantityBBL(

            truckDatabase[selectedTruck]
                ?.capacity?.bbl || 0

        );

    }

},[
    selectedTruck,
    loadingMode
]);


/* ===========================================================
   AUTO LOAD SELECTED BARGE CAPACITY
=========================================================== */

useEffect(() => {

    if(
        loadingMode==="ship" &&
        selectedBarge
    ){

        setQuantityBBL(

            bargeDatabase[selectedBarge]
                ?.capacity?.bbl || 0

        );

    }

},[
    selectedBarge,
    loadingMode
]);

















  return (
    <div className="LoadingGantry-container">

      {/* TITLE */}
      <h2
        style={{
          position: "absolute",
          top: "0px",
          left: "240px",
          color: "white",
          background: "rgb(30, 5, 250)",
          padding: "2px 353px",
          zIndex: 10,
        }}
      >
        LOADING GANTRY
      </h2>


 {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-3901 */}
      <Valve
        className="XV-3901"
        tag="XV_3901"
        x={528}
        y={255}
        isClosed={valves.XV_3901}
        toggle={toggleValve}
        r={90}
      />





      {showReceipt && (
        <LoadingReceipt
            onClose={() => setShowReceipt(false)}
        />

    )}





      {/* ==========================================
          LOADING MODE SELECTION PANEL
      ========================================== */}

      <div
          className="loading-mode-panel"
          style={{
              position: "absolute",

              left: 560,      // X Position
              top: 80,        // Y Position

              width: 520,     // Panel Width
              height: 210,    // Panel Height

              transform: "scale(0.6)",   // Resize
              transformOrigin: "top left",
          }}
      >

          <div className="loading-mode-title">
             NK TECH LOADING MODE SELECTION
          </div>

          <div className="loading-mode-buttons">

              <button
                  className={`mode-btn ${
                      loadingMode === "truck"
                          ? "active-green"
                          : loadingMode === "ship"
                          ? "inactive-red"
                          : ""
                  }`}
                  onClick={() => setLoadingMode("truck")}
              >
                  CHOOSE
              </button>

              <button
                  className={`mode-btn ${
                      loadingMode === "ship"
                          ? "active-green"
                          : loadingMode === "truck"
                          ? "inactive-red"
                          : ""
                  }`}
                  onClick={() => setLoadingMode("ship")}
              >
                  CHOOSE
              </button>

          </div>

          <div className="loading-mode-boxes">

              <div
                  className={`loading-box ${
                      loadingMode === "truck"
                          ? "enabled"
                          : "disabled"
                  }`}
                  onClick={() => {
              if (loadingMode === "truck") {
                  setShowSelector(true);
              }
          }}
              >
                  TRUCK LOADING
              </div>

              <div
                  className={`loading-box ${
                      loadingMode === "ship"
                          ? "enabled"
                          : "disabled"
                  }`}
                  onClick={() => {
              if (loadingMode === "ship") {
                  setShowSelector(true);
              }
          }}
              >
                  BARGE LOADING
              </div>

          </div>

      </div>


      {showSelector && (

<div className="equipment-selector">

    <div className="selector-header">

        <div>

            {loadingMode === "truck"
                ? "SELECT TRUCK"
                : "SELECT BARGE"}

        </div>

        <button
            className="selector-close"
            onClick={() => setShowSelector(false)}
        >
            ✕
        </button>

    </div>

    <div className="selector-list">

        {Object.entries(
            loadingMode === "truck"
                ? truckDatabase
                : bargeDatabase
        ).map(([key,item])=>(

            <div

                key={key}

                className="selector-item"

                onClick={() => {

                    if (loadingMode==="truck"){

                        setSelectedTruck(key);

                    }else{

                        setSelectedBarge(key);

                    }

                    setShowSelector(false);

                }}

            >

                {item.name}

            </div>

        ))}

    </div>

</div>

)}





<div className="loading-selected">

    {loadingMode === "truck"

        ? truckDatabase[selectedTruck]?.name

        : bargeDatabase[selectedBarge]?.name}

</div>



{/* ===========================================
    LOADING INFORMATION PANEL
=========================================== */}

{(
    (loadingMode === "truck" && selectedTruck) ||
    (loadingMode === "ship" && selectedBarge)
) && (

<div
    className="loading-info-panel"

    style={{

        position:"absolute",

        left:990,

        top:55,

        width:420,

        height:670,

        transform:"scale(0.70)",

        transformOrigin:"top left"

    }}
>

      <div className="loading-info-header">

        <span>

            NK Tech Industrial DCS and Digital Twin Solution

        </span>

    </div>

    <div className="loading-info-title">
        LOADING INFORMATION PANEL
    </div>

    <div className="loading-grid">

        <div className="loading-row">
            <label>QUANTITY (BBL):</label>

            <input
                type="number"
                value={quantityBBL}
                onChange={(e)=>
                    setQuantityBBL(Number(e.target.value)||0)
                }
            />
        </div>

        <div className="loading-row">
            <label>QUANTITY (MT):</label>

            <input
                value={quantityMT.toFixed(2)}
                readOnly
            />
        </div>

        <div className="loading-row">
            <label>QUANTITY (LITRES):</label>

            <input
                value={quantityLitres.toFixed(0)}
                readOnly
            />
        </div>

        <div className="loading-row">
            <label>FLOW (BPM):</label>

            <input
                value={flowBBL.toFixed(2)}
                readOnly
            />
        </div>

        <div className="loading-row">
            <label>FLOW (L/MIN):</label>

            <input
                value={flowLPM.toFixed(2)}
                readOnly
            />
        </div>

        <div className="loading-row">
            <label>FLOW ACCUM (BBL):</label>

            <input
                value={accumulatorBBL.toFixed(2)}
                readOnly
            />
        </div>

        <div className="loading-row">
            <label>FLOW ACCUM (LITRES):</label>

            <input
                value={accumulatorLitres.toFixed(0)}
                readOnly
            />
        </div>

    </div>

    <div className="loading-buttons">

    <button
        className="reset-btn quantity"
        onClick={resetQuantity}
    >
        RESET QUANTITY
    </button>

    <button
        className="reset-btn accumulator"
        onClick={resetAccumulator}
    >
        RESET ACCUMULATOR
    </button>

    <button
    className="receipt-btn"
    onClick={() => setShowReceipt(true)}
      >
          RECEIPT
      </button>

</div>

    <div className={`batch-status ${batchStatus.toLowerCase()}`}>

    {batchStatus==="READY" && "READY FOR LOADING"}

    {batchStatus==="LOADING" && "LOADING IN PROGRESS"}

    {batchStatus==="COMPLETE" && "✔ BATCH COMPLETE"}

    {batchStatus==="INTERRUPTED" && "⚠ BATCH INTERRUPTED"}

    {batchStatus==="RESET" && "✖ BATCH RESET BY OPERATOR"}

</div>

<div className="current-product-panel">

    <div className="current-product-title">

        CURRENT PRODUCT

    </div>

    <div
        className={`current-product-value ${
            currentProduct === "NO PRODUCT"
                ? "product-none"
                : "product-active"
        }`}
    >

        {currentProduct}

    </div>

</div>

</div>

)}








              <button
                  disabled={loadingMode !== "ship"}
                  onClick={() => {
                    handleBargeMovement();
                  }}
                  style={{
                    position: "fixed",
                    top: "340px",
                    left: "20px",
                    padding: "10px 30px",
                    background: loadingMode === "ship" ? "#001eff" : "#808080",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    fontWeight: "bold",
                    cursor: loadingMode === "ship" ? "pointer" : "not-allowed",
                    opacity: loadingMode === "ship" ? 1 : 0.5,
                    pointerEvents: loadingMode === "ship" ? "auto" : "none",
                    zIndex: 1000,
                    transition: "0.3s ease",
                  }}
                >
            {isBargeArrived ? "Barge Departure" : "Barge Arrival"}
          </button>




        

      {/* ================= SVG RESIZE WRAPPER ================= */}
      <div
          style={{
            position: "absolute",
            left: bargePosition.left,
            top: bargePosition.top,
            width: "900px",
            height: "450px",
            transform: `scale(1) rotateY(${rotation})`,
            transformOrigin: "center center",
            transition: "left 8s linear, top 8s linear, transform 1s ease",
          }}
        >




        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1800 900"
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid meet"
        >

          <defs>

            <linearGradient id="hullRed" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#c40000" />
              <stop offset="100%" stopColor="#6b0000" />
            </linearGradient>

            <linearGradient id="superstructure" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#f6f6f6" />
              <stop offset="100%" stopColor="#bfbfbf" />
            </linearGradient>

            <linearGradient id="windowBlue" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#0f5eff" />
              <stop offset="100%" stopColor="#002e8c" />
            </linearGradient>

          </defs>

          {/* ===================================================== */}
          {/* MAIN VESSEL */}
          {/* ===================================================== */}

          <g id="crudeBarge">

            {/* ===================================================== */}
            {/* HULL */}
            {/* ===================================================== */}

            <g id="hull">

              <path
                d="
                M80 620
                L1420 620
                L1620 670
                L1580 790
                L260 790
                L80 700
                Z"
                fill="url(#hullRed)"
                stroke="#3b0000"
                strokeWidth="4"
              />

              <rect
                x="70"
                y="585"
                width="1360"
                height="35"
                fill="#000"
              />

              <rect
                x="70"
                y="575"
                width="1360"
                height="10"
                fill="#d80000"
              />


            </g>

            {/* ===================================================== */}
            {/* HULL STIFFENERS */}
            {/* ===================================================== */}

            <g
              id="stiffeners"
              stroke="#900000"
              strokeWidth="6"
            >

              <line x1="500" y1="620" x2="450" y2="790" />
              <line x1="700" y1="620" x2="650" y2="790" />
              <line x1="900" y1="620" x2="850" y2="790" />
              <line x1="1100" y1="620" x2="1050" y2="790" />
              <line x1="1300" y1="620" x2="1250" y2="790" />

            </g>

            {/* ===================================================== */}
            {/* NK TECH BRANDING */}
            {/* ===================================================== */}

            <g id="branding">

              <text
                x="520"
                y="705"
                fontSize="100"
                fontWeight="900"
                fontFamily="Arial Black"
                fill="#ffffff"
                letterSpacing="4"
              >
                NK Tech
              </text>

            </g>

            {/* ===================================================== */}
            {/* PROPELLER TUNNELS */}
            {/* ===================================================== */}

            <g id="propellers">

              <rect
                x="120"
                y="700"
                width="45"
                height="90"
                fill="#8a0000"
              />

              <rect
                x="200"
                y="700"
                width="45"
                height="90"
                fill="#8a0000"
              />

              <circle
                cx="142"
                cy="780"
                r="22"
                fill="#c7a100"
              />

              <circle
                cx="222"
                cy="780"
                r="22"
                fill="#c7a100"
              />

            </g>

            {/* ===================================================== */}
            {/* MAIN DECK */}
            {/* ===================================================== */}

            <g id="mainDeck">

              <rect
                x="850"
                y="520"
                width="500"
                height="60"
                fill="#3b3b3b"
              />

              <rect
                x="860"
                y="500"
                width="480"
                height="15"
                fill="#0f5c0f"
              />

              <rect
                x="860"
                y="535"
                width="480"
                height="15"
                fill="#0f5c0f"
              />

            </g>

            {/* ===================================================== */}
            {/* CARGO PIPELINES */}
            {/* ===================================================== */}

            <g
              id="cargoLines"
              stroke="#0a6d0a"
              strokeWidth="8"
              fill="none"
            >

              <line x1="860" y1="510" x2="1320" y2="510" />
              <line x1="860" y1="545" x2="1320" y2="545" />

              <line x1="950" y1="485" x2="950" y2="565" />
              <line x1="1080" y1="485" x2="1080" y2="565" />
              <line x1="1210" y1="485" x2="1210" y2="565" />

            </g>

            {/* ===================================================== */}
            {/* PIPE VALVES */}
            {/* ===================================================== */}

            <g id="valves">

              <circle cx="950" cy="528" r="12" fill="#cc0000" />
              <circle cx="1080" cy="528" r="12" fill="#cc0000" />
              <circle cx="1210" cy="528" r="12" fill="#cc0000" />

            </g>

            {/* ===================================================== */}
            {/* SUPERSTRUCTURE LOWER */}
            {/* ===================================================== */}

            <g id="lowerHouse">

              <rect
                x="260"
                y="430"
                width="600"
                height="150"
                fill="url(#superstructure)"
                stroke="#666"
                strokeWidth="3"
              />

            </g>

            {/* ===================================================== */}
            {/* WINDOWS */}
            {/* ===================================================== */}

            <g id="windows">

              <rect x="330" y="470" width="40" height="35" rx="5" fill="url(#windowBlue)" />
              <rect x="390" y="470" width="40" height="35" rx="5" fill="url(#windowBlue)" />
              <rect x="450" y="470" width="40" height="35" rx="5" fill="url(#windowBlue)" />
              <rect x="510" y="470" width="40" height="35" rx="5" fill="url(#windowBlue)" />
              <rect x="570" y="470" width="40" height="35" rx="5" fill="url(#windowBlue)" />
              <rect x="630" y="470" width="40" height="35" rx="5" fill="url(#windowBlue)" />
              <rect x="690" y="470" width="40" height="35" rx="5" fill="url(#windowBlue)" />

            </g>

            {/* ===================================================== */}
            {/* WHEELHOUSE */}
            {/* ===================================================== */}

            <g id="wheelhouse">

              <rect
                x="500"
                y="270"
                width="220"
                height="160"
                fill="url(#superstructure)"
                stroke="#666"
                strokeWidth="3"
              />

              <polygon
                points="
                480,270
                740,270
                710,240
                510,240"
                fill="#b00000"
              />

              <rect x="530" y="300" width="45" height="40" fill="#0048ff" />
              <rect x="585" y="300" width="45" height="40" fill="#0048ff" />
              <rect x="640" y="300" width="45" height="40" fill="#0048ff" />

            </g>

            {/* ===================================================== */}
            {/* FUNNEL */}
            {/* ===================================================== */}

            <g id="funnel">

              <rect
                x="310"
                y="310"
                width="85"
                height="110"
                fill="#202020"
              />

              <rect
                x="310"
                y="310"
                width="85"
                height="25"
                fill="#93fd09"
              />

            </g>

            {/* ===================================================== */}
            {/* LADDER */}
            {/* ===================================================== */}

            <g
              id="ladder"
              stroke="#d0d0d0"
              strokeWidth="3"
            >

              <line x1="360" y1="430" x2="430" y2="320" />
              <line x1="380" y1="430" x2="450" y2="320" />

              <line x1="365" y1="410" x2="440" y2="410" />
              <line x1="370" y1="390" x2="445" y2="390" />
              <line x1="375" y1="370" x2="450" y2="370" />
              <line x1="380" y1="350" x2="455" y2="350" />

            </g>

            {/* ===================================================== */}
            {/* RAILINGS */}
            {/* ===================================================== */}

            <g
              id="railings"
              stroke="#dddddd"
              strokeWidth="3"
            >

              <line x1="230" y1="420" x2="870" y2="420" />
              <line x1="230" y1="400" x2="870" y2="400" />

              <line x1="230" y1="420" x2="230" y2="520" />
              <line x1="280" y1="420" x2="280" y2="520" />
              <line x1="330" y1="420" x2="330" y2="520" />
              <line x1="380" y1="420" x2="380" y2="520" />
              <line x1="430" y1="420" x2="430" y2="520" />
              <line x1="480" y1="420" x2="480" y2="520" />
              <line x1="530" y1="420" x2="530" y2="520" />
              <line x1="580" y1="420" x2="580" y2="520" />
              <line x1="630" y1="420" x2="630" y2="520" />
              <line x1="680" y1="420" x2="680" y2="520" />
              <line x1="730" y1="420" x2="730" y2="520" />
              <line x1="780" y1="420" x2="780" y2="520" />
              <line x1="830" y1="420" x2="830" y2="520" />

            </g>

            {/* ===================================================== */}
            {/* LIFE BUOYS */}
            {/* ===================================================== */}

            <g id="lifebuoys">

              <circle
                cx="520"
                cy="420"
                r="16"
                fill="none"
                stroke="#ff4444"
                strokeWidth="6"
              />

              <circle
                cx="270"
                cy="500"
                r="16"
                fill="none"
                stroke="#ff4444"
                strokeWidth="6"
              />

            </g>

            {/* ===================================================== */}
            {/* MAST */}
            {/* ===================================================== */}

            <g id="mast">

              <line
                x1="620"
                y1="120"
                x2="620"
                y2="270"
                stroke="#666"
                strokeWidth="5"
              />

              <line
                x1="620"
                y1="170"
                x2="690"
                y2="170"
                stroke="#666"
                strokeWidth="3"
              />

              <rect
                x="690"
                y="162"
                width="12"
                height="12"
                fill="green"
              />

              <rect
                x="708"
                y="162"
                width="12"
                height="12"
                fill="red"
              />

            </g>

            {/* ===================================================== */}
            {/* ANTENNAS */}
            {/* ===================================================== */}

            <g
              id="antennas"
              stroke="#444"
              strokeWidth="3"
            >

              <line x1="560" y1="240" x2="560" y2="180" />
              <line x1="590" y1="240" x2="590" y2="170" />
              <line x1="650" y1="240" x2="650" y2="185" />

            </g>

          </g>

        </svg>


        
                <LevelTransmitterIndicator
                  tag="LT_502"
                  totalLevel={[quantityBBL*1.04]}
                  inflows={[flowBBL]}
                  outflows={[FIC_5903]}
                  responseFactor={0.05}
                  columnX={124}
                  columnY={313}
                  columnWidth={609}
                  columnHeight={75}
                  textX={80}
                  textY={260}
                  showFlow={true}
                    backgroundOpacity={0.01}
                  liquidOpacity={0.4}
                  service="diesel"
                />


      </div>





      
      
              <button
                  disabled={loadingMode !== "truck"}
                  onClick={() => {
                    handleTruckMovement();
                  }}
                  style={{
                    position: "fixed",
                    top: "300px",
                    left: "20px",
                    padding: "10px 30px",
                    background: loadingMode === "truck" ? "#001eff" : "#808080",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    fontWeight: "bold",
                    cursor: loadingMode === "truck" ? "pointer" : "not-allowed",
                    opacity: loadingMode === "truck" ? 1 : 0.5,
                    pointerEvents: loadingMode === "truck" ? "auto" : "none",
                    zIndex: 1000,
                    transition: "0.3s ease",
                  }}
                >
                  {isTruckArrived ? "Truck Departure" : "Truck Arrival"}
                </button>
      
      
      
              {/* ================= SVG RESIZE WRAPPER ================= */}
            <div 
                style={{
                  position: "absolute",
                  left: truckPosition.left,
                  top: truckPosition.top,
                  width: "900px",
                  height: "450px",
                  transform: `scale(1) rotateY(${rotation1})`,
                  opacity: truckVisible ? 1 : 0,
                  pointerEvents: truckVisible ? "auto" : "none",
                  transformOrigin: "center center",
                  transition: "left 8s linear, top 8s linear, transform 1s ease",
                }}
              >
      
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 2200 1000">
      
                <defs>
      
                <linearGradient id="tankMetal"
                x1="0%" y1="0%"
                x2="0%" y2="100%">
      
                <stop offset="0%" stop-color="#fefefe"/>
                <stop offset="25%" stop-color="#d9d9d9"/>
                <stop offset="50%" stop-color="#8ea2b8"/>
                <stop offset="75%" stop-color="#f0f0f0"/>
                <stop offset="100%" stop-color="#c4c4c4"/>
      
                </linearGradient>
      
                <linearGradient id="cabWhite"
                x1="0%"
                y1="0%"
                x2="0%"
                y2="100%">
      
                <stop offset="0%" stop-color="#ffffff"/>
                <stop offset="100%" stop-color="#d7d7d7"/>
      
                </linearGradient>
      
                </defs>
      
                <g
                      id="crudeTruck"
                      transform="translate(2200,0) scale(-1,1)"
                    >
      
                {/*  ====================================================== */}
                {/*  CAB --*/}
                {/*  ====================================================== */}
      
                <g id="cab">
      
                <path
                d="
                M120 620
                L120 430
                L230 360
                L470 280
                L620 280
                L620 620
                Z"
                fill="url(#cabWhite)"
                stroke="#777"
                stroke-width="4"/>
      
                {/*-- Door --*/}
      
                <rect
                x="380"
                y="300"
                width="180"
                height="260"
                rx="10"
                fill="#f7f7f7"
                stroke="#666"
                stroke-width="3"/>
      
               {/*-- Window --*/}
      
                <polygon
                points="
                400,320
                540,320
                540,450
                420,450
                400,430"
                fill="#5fb8ff"
                stroke="#2b5f8f"
                stroke-width="3"/>
      
                {/*-- Mirror --*/}
      
                <line
                x1="370"
                y1="350"
                x2="330"
                y2="340"
                stroke="#666"
                stroke-width="5"/>
      
                <rect
                x="300"
                y="325"
                width="35"
                height="25"
                fill="#999"/>
      
                {/*-- Headlight --*/}
      
                <ellipse
                cx="180"
                cy="540"
                rx="30"
                ry="22"
                fill="#fff7b3"
                stroke="#888"/>
      
                </g>
      
                {/* ====================================================== */}
                {/* TANK --*/}
                {/* ====================================================== */}
      
                <g id="tank">
      
                <rect
                x="650"
                y="260"
                width="1050"
                height="300"
                rx="150"
                fill="url(#tankMetal)"
                stroke="#999"
                stroke-width="4"/>
      
                {/* Reflective band */}
      
                <rect
                x="680"
                y="360"
                width="980"
                height="40"
                fill="#4f8ed7"
                opacity="0.45"/>
      
                {/* Tank rings */}
      
                <line x1="900" y1="260" x2="900" y2="560"
                stroke="#bdbdbd"
                stroke-width="3"/>
      
                <line x1="1150" y1="260" x2="1150" y2="560"
                stroke="#bdbdbd"
                stroke-width="3"/>
      
                <line x1="1400" y1="260" x2="1400" y2="560"
                stroke="#bdbdbd"
                stroke-width="3"/>
      
                </g>
      
                {/* ====================================================== */}
                {/* CHASSIS */}
                {/* ====================================================== */}
      
                <g id="chassis">
      
                <rect
                x="420"
                y="560"
                width="1350"
                height="35"
                fill="#2a2a2a"/>
      
                </g>
      
                  <g id="chassis">
      
                <rect
                x="150"
                y="615"
                width="1620"
                height="105"
                fill="#2a2a2a"/>
      
                </g>
      
                {/* ====================================================== */}
                {/* STORAGE BOXES */}
                {/* ====================================================== */}
      
                <g id="boxes">
      
                <rect
                x="680"
                y="620"
                width="280"
                height="140"
                fill="#7d8895"/>
      
                <rect
                x="1000"
                y="620"
                width="280"
                height="140"
                fill="#7d8895"/>
      
                </g>
      
                {/* ====================================================== */}
                {/* PIPING */}
                {/* ====================================================== */}
      
                <g id="piping">
      
                <line
                x1="720"
                y1="590"
                x2="1650"
                y2="300"
                stroke="#c0c0c0"
                stroke-width="22"/>
      
                <line
                x1="590"
                y1="290"
                x2="1650"
                y2="576"
                stroke="#c0c0c0"
                stroke-width="22"/>
      
                <circle
                cx="980"
                cy="590"
                r="45"
                fill="#ff0000"/>
      
                <circle
                cx="1280"
                cy="590"
                r="45"
                fill="#ff0000"/>
      
                <circle
                cx="680"
                cy="590"
                r="45"
                fill="#ff0000"/>
      
                <circle
                cx="1630"
                cy="590"
                r="45"
                fill="#ff0000"/>
      
                </g>
      
                {/* ====================================================== */}
                {/* FRONT WHEEL */}
                {/* ====================================================== */}
      
                <g id="frontWheel" transform="translate(400 720)">
                  <g className={truckMoving ? "wheel-spin" : ""}>
                   <circle
                r="95"
                fill="#111"/>
      
                <circle
                r="70"
                fill="#b4b0b0"/>
      
                <circle
                r="18"
                fill="#666"/>
      
                <line x1="-60" y1="0" x2="60" y2="0"
                stroke="#06f712"
                stroke-width="5"/>
      
                <line x1="0" y1="-60" x2="0" y2="60"
                stroke="#888"
                stroke-width="5"/>
      
                <line x1="-45" y1="-45" x2="45" y2="45"
                stroke="#5e08fd"
                stroke-width="5"/>
      
                <line x1="-45" y1="45" x2="45" y2="-45"
                stroke="#888"
                stroke-width="5"/>
      
                  </g>
                </g>
      
      
      
                {/* ====================================================== */}
                {/* REAR WHEEL */}
                {/* ====================================================== */}
      
                <g id="rearWheel" transform="translate(1450 720)">
                  <g className={truckMoving ? "wheel-spin" : "5"}>
                    <circle
                r="95"
                fill="#111"/>
      
                <circle
                r="70"
                fill="#cfcaca"/>
      
                <circle
                r="18"
                fill="#666"/>
      
                <line x1="-60" y1="0" x2="60" y2="0"
                stroke="#0307fa"
                stroke-width="5"/>
      
                <line x1="0" y1="-60" x2="0" y2="60"
                stroke="#888"
                stroke-width="5"/>
      
                <line x1="-45" y1="-45" x2="45" y2="45"
                stroke="#e1fa02"
                stroke-width="5"/>
      
                <line x1="-45" y1="45" x2="45" y2="-45"
                stroke="#888"
                stroke-width="5"/>
                  </g>
                </g>
            
                </g>
      
      
                {/* ====================================================== */}
                {/* NK TECH LOGO */}
                {/* ====================================================== */}
                  <image
                      href={nkLogo}
                      x="1645"
                      y="420"
                      width="160"
                      height="100"
                      transform="rotate(0 1080 380)"
                      preserveAspectRatio="xMidYMid meet"
                  />
      
                <text
                x="730"
                y="430"
                font-size="70"
                font-weight="900"
                fill="#003366">
      
                NK Tech Trucks
      
                </text>
      
                </svg>
      
      
                
                <LevelTransmitterIndicator
                  tag="LT_501"
                  totalLevel={[quantityBBL*1.04]}
                  inflows={[flowBBL]}
                  outflows={[FIC_5902]}
                  responseFactor={0.05}
                  columnX={244}
                  columnY={110}
                  columnWidth={349}
                  columnHeight={115}
                  textX={160}
                  textY={190}
                  showFlow={true}
                    backgroundOpacity={0.01}
                  liquidOpacity={0.4}
                  service="diesel"
                />

                      
      
            </div>



    </div>
  );
}

export default LoadingGantry;